var RADIUS = 42;
var circleAttributes = {
  cx: 50,
  cy: 50,
  r: RADIUS,
  strokeLinecap: 'round'
};
export function useCircleSvg(value) {
  var dasharray = Math.PI * RADIUS * 2;
  var determinant = value * (dasharray / 100);
  var strokeDasharray = "".concat(determinant, " ").concat(dasharray - determinant);
  return {
    circleAttributes,
    strokeDasharray
  };
}
//# sourceMappingURL=useCircleSvg.js.map